export default __webpack_public_path__ + "static/media/img_baseCottonBunny_cotton_p.91fbe11c.jpg";